import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import queryString, { ParsedQuery } from 'query-string';

export const useQueryParams = (): ParsedQuery => {
  const location = useLocation();

  return useMemo(() => queryString.parse(location.search), [location.search]);
};
